// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"589":"7cd4cd8a","775":"6903635b","811":"fd33e042","927":"c2117fae"}[chunkId] + ".chunk.css";
};